import { MantineProvider, useMantineTheme } from '@mantine/core'
import { ARC_PRIMARY_SHADE_INDEX, ARC_PURPLE_SHADES } from '../../themes/ArcTheme'
import { ArcAuthPage, ARC_FONT_FAMILY } from './ArcAuthPage'

interface ArcAuthShellProps {
  readonly children: React.ReactNode
}

/**
 * Scopes the arcmosaico.ai purple as the Mantine primary color for everything
 * inside the Arc auth screens (buttons, anchors, checkboxes), on top of the
 * ArcAuthPage visual shell (AR-792).
 */
export const ArcAuthShell = ({ children }: ArcAuthShellProps) => {
  // MantineProvider inherit merges top-level keys shallowly: spread the parent
  // palettes so overriding `colors` doesn't drop them
  const parentTheme = useMantineTheme()

  return (
    <MantineProvider
      inherit
      theme={{
        primaryColor: 'arcPurple',
        primaryShade: ARC_PRIMARY_SHADE_INDEX,
        colors: { ...parentTheme.colors, arcPurple: ARC_PURPLE_SHADES },
        fontFamily: ARC_FONT_FAMILY,
        headings: { ...parentTheme.headings, fontFamily: ARC_FONT_FAMILY },
      }}
    >
      <ArcAuthPage>{children}</ArcAuthPage>
    </MantineProvider>
  )
}
